import { usePageTitle } from "../hooks/usePageTitle";
import Button from "../components/ui/Button";

export default function NotFound() {
  usePageTitle("Page Not Found");
  return (
    <section style={{ textAlign: "center", padding: "5rem 20px", maxWidth: 480, margin: "0 auto" }}>
      <p style={{ fontFamily: "var(--font-voice)", fontSize: 64, color: "var(--lilac-deep)", margin: "0 0 12px", fontWeight: 700 }}>
        404
      </p>
      <h1 style={{ fontFamily: "var(--font-voice)", fontSize: 24, color: "var(--navy)", margin: "0 0 12px" }}>
        That page doesn&rsquo;t exist.
      </h1>
      <p style={{ fontSize: 14, color: "var(--text-secondary)", margin: "0 0 28px", lineHeight: 1.6 }}>
        The link might be out of date, or the page has moved.
      </p>
      <Button to="/">Back to Home</Button>
    </section>
  );
}
